import * as angular from 'angular';

export class ResetSuccessController {
    static $inject = ['$translate'];
    constructor(private $translate: angular.translate.ITranslateService) {}
}

angular.module('naut')
    .component('resetSuccess', {
        template: require('./resetSuccess.html'),
        controller: ResetSuccessController,
        controllerAs: 'ctrl'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/components/resetSuccess/resetSuccess.component.ts